/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getList = (payload, callback) =>
  req.list(
    c.GET_BUILDING_KIND_LIST,
    'api/v1/rpt/administrator/buildings/settings/building_kinds?isPaginate=1',
    payload,
    callback
  );

export const showData = (id, payload, callback) =>
  req.item(
    c.SHOW_DATA,
    `api/v1/rpt/administrator/buildings/settings/building_kinds/${id}`,
    payload,
    callback
  );

export const createData = (payload, callback) =>
  req.create(
    c.CREATE_DATA,
    'api/v1/rpt/administrator/buildings/settings/building_kinds',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateData = (id, payload, callback) =>
  req.update(
    c.UPDATE_DATA,
    `api/v1/rpt/administrator/buildings/settings/building_kinds/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeData = (id, payload, callback) =>
  req.remove(
    c.REMOVE_DATA,
    `api/v1/rpt/administrator/buildings/settings/building_kinds/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getStructuralTypeList = (kindId, payload, callback) =>
  req.list(
    c.GET_BUILDING_STRUCTURAL_TYPE_LIST,
    `api/v1/rpt/administrator/buildings/settings/building_kinds/${kindId}/building_structural_types`,
    payload,
    callback
  );

export const showStructuralTypeData = (kindId, id, payload, callback) =>
  req.item(
    c.SHOW_STRUCTURAL_TYPE,
    `api/v1/rpt/administrator/buildings/settings/building_kinds/${kindId}/building_structural_types/${id}`,
    payload,
    callback
  );

export const createStructuralTypeData = (kindId, payload, callback) =>
  req.create(
    c.CREATE_STRUCTURAL_TYPE,
    `api/v1/rpt/administrator/buildings/settings/building_kinds/${kindId}/building_structural_types`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateStructuralTypeData = (kindId, id, payload, callback) =>
  req.update(
    c.UPDATE_STRUCTURAL_TYPE,
    `api/v1/rpt/administrator/buildings/settings/building_kinds/${kindId}/building_structural_types/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeStructuralTypeData = (kindId, id, payload, callback) =>
  req.remove(
    c.REMOVE_STRUCTURAL_TYPE,
    `api/v1/rpt/administrator/buildings/settings/building_kinds/${kindId}/building_structural_types/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getOrdinanceRevisionList = (payload, callback) =>
  req.list(
    c.GET_ORDINANCE_REVISION_LIST,
    `api/v1/rpt/administrator/settings/ordinance_revisions`,
    payload,
    callback
  );
